import React, { useState, useEffect } from 'react';
import { Header } from 'semantic-ui-react';


const ShowTotal = ({ ...props }) => {
  const [subtotal, setSubtotal] = useState(0);

  useEffect(() => {
    if (props?.values?.productDetails && props?.values?.productDetails?.length > 0) {
      let total = 0;
      props.values.productDetails.forEach(element => {
        total += element.taxableAmount;
      });

      setSubtotal(total)
    }
  }, [props.values.subTotal, props.values.finalAmount, props.values.productDetails, props.subTotal, props.values.calulatedRate])



  return (
    <>
      <Header className="labelName" size="tiny">₹ {props.subTotal}</Header>
    </>
  )
}

export default ShowTotal











